import { Icon } from '../icons/Icon.js';
import { useToasts, type ToastKind } from '../hooks/useToasts.js';

const ICON_FOR: Record<ToastKind, 'info' | 'checkCircle' | 'error'> = {
  info: 'info',
  ok: 'checkCircle',
  err: 'error',
};

export function ToastContainer() {
  const toasts = useToasts();
  return (
    <div className="toast-root">
      {toasts.map((t) => (
        <div key={t.id} className={'toast ' + t.kind}>
          <Icon name={ICON_FOR[t.kind]} size={16} />
          <span>{t.msg}</span>
        </div>
      ))}
    </div>
  );
}
